import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AcquisitionDataOut, Client, PermissionsEnum } from '../../../../api/api-reference';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../services/auth.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SecondsToText } from '../../../../pipes/seconds-to-text';

@Component({
  selector: 'app-acquisition-details',
  standalone: true,
  imports: [CommonModule, TranslateModule, AngularSvgIconModule, SecondsToText],
  templateUrl: './acquisition-details.component.html',
  styleUrl: './acquisition-details.component.scss',
})
export class AcquisitionDetailsComponent {
  @Input() id: string | undefined;
  @Output() closeSignal = new EventEmitter<boolean>();
  public PermissionsEnum = PermissionsEnum;
  acquisition: AcquisitionDataOut = new AcquisitionDataOut();

    toggleModal() {
      this.closeSignal.emit();
    }

  constructor(
    private toastr: ToastrService,
    private client: Client,
    public authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.getAcquisitionById();
  }

  getAcquisitionById() {
    this.client.getAcquisition(this.id!).subscribe({
      next:(result)=>{
        this.acquisition=result;
      },
      error:(err)=>{
        this.toastr.error(err);
      }
     });
    }
}
